export type TopSellersRegion = {
  cc: string;
  name: string;
  flag: string;
};

export const TOPSELLERS_REGIONS: TopSellersRegion[] = [
  { cc: "global", name: "Global", flag: "🌐" },

  { cc: "at", name: "Austria", flag: "🇦🇹" },
  { cc: "au", name: "Australia", flag: "🇦🇺" },
  { cc: "be", name: "Belgium", flag: "🇧🇪" },
  { cc: "br", name: "Brazil", flag: "🇧🇷" },
  { cc: "ca", name: "Canada", flag: "🇨🇦" },
  { cc: "ch", name: "Switzerland", flag: "🇨🇭" },
  { cc: "cz", name: "Czech Republic", flag: "🇨🇿" },
  { cc: "de", name: "Germany", flag: "🇩🇪" },
  { cc: "dk", name: "Denmark", flag: "🇩🇰" },
  { cc: "es", name: "Spain", flag: "🇪🇸" },
  { cc: "fi", name: "Finland", flag: "🇫🇮" },
  { cc: "fr", name: "France", flag: "🇫🇷" },
  { cc: "gb", name: "United Kingdom", flag: "🇬🇧" },
  { cc: "hk", name: "Hong Kong", flag: "🇭🇰" },
  { cc: "it", name: "Italy", flag: "🇮🇹" },
  { cc: "jp", name: "Japan", flag: "🇯🇵" },
  { cc: "kr", name: "Korea, Republic of", flag: "🇰🇷" },
  { cc: "nl", name: "Netherlands", flag: "🇳🇱" },
  { cc: "no", name: "Norway", flag: "🇳🇴" },
  { cc: "nz", name: "New Zealand", flag: "🇳🇿" },
  { cc: "pl", name: "Poland", flag: "🇵🇱" },
  { cc: "ru", name: "Russian Federation", flag: "🇷🇺" },
  { cc: "se", name: "Sweden", flag: "🇸🇪" },
  { cc: "sg", name: "Singapore", flag: "🇸🇬" },
  { cc: "th", name: "Thailand", flag: "🇹🇭" },
  { cc: "tr", name: "Turkey", flag: "🇹🇷" },
  { cc: "tw", name: "Taiwan", flag: "🇹🇼" },
  { cc: "us", name: "United States", flag: "🇺🇸" },
];

export function normalizeTopSellersRegion(cc: string | undefined): string {
  const value = (cc ?? "global").trim().toLowerCase();
  return TOPSELLERS_REGIONS.some((r) => r.cc === value) ? value : "global";
}

/**
 * Map a visitor ISO country (e.g. from the `x-vercel-ip-country` header) to a
 * tracked region for geo-located lists like New & Trending. Falls back to the
 * United States when the country isn't tracked. Never returns "global"
 * (New & Trending has no global list).
 */
export function resolveVisitorRegion(
  rawCc: string | null | undefined,
): TopSellersRegion {
  const cc = (rawCc ?? "").trim().toLowerCase();
  const match = TOPSELLERS_REGIONS.find((r) => r.cc === cc && r.cc !== "global");
  return match ?? TOPSELLERS_REGIONS.find((r) => r.cc === "us")!;
}

export type TopSellersRegionSelectOption = {
  value: string;
  label: string;
};

export function getTopSellersRegionSelectOptions(): TopSellersRegionSelectOption[] {
  return TOPSELLERS_REGIONS.map((r) => ({
    value: r.cc,
    label: `${r.flag} ${r.name}`,
  }));
}

export type TopSellersRegionIconOption = {
  value: string;
  label: string;
  emoji: string;
};

export function getTopSellersRegionIconOptions(): TopSellersRegionIconOption[] {
  return TOPSELLERS_REGIONS.map((r) => ({
    value: r.cc,
    label: r.name,
    emoji: r.flag,
  }));
}
